import extendedPropertyUri from "owa-service/lib/factory/extendedPropertyUri";
import type ExtendedPropertyUri from "owa-service/lib/contract/ExtendedPropertyUri";
import { COPILOT_DRAFT_GENERATION_PROPERTIES_NAME, MESSAGE_PROPERTY_SET_ID } from "./constants";

export default function getCopilotDraftGenerationPropertyUriForRequest(): ExtendedPropertyUri {
    return extendedPropertyUri({
        PropertyName: COPILOT_DRAFT_GENERATION_PROPERTIES_NAME,
        PropertySetId: MESSAGE_PROPERTY_SET_ID,
        PropertyType: "String",
    });
}
